import { Injectable, Injector } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { SlackUrlToken } from '../module';

import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/map';
import'rxjs/add/observable/of';
export class FeedbackService {
private slackUrlToken: string;
/**
 * @param {?} http
 * @param {?} injector
 */
constructor(private http: Http,
private injector: Injector) {
    this.slackUrlToken = this.injector.get(SlackUrlToken);
  }
/**
 * @param {?} slackObject
 * @return {?}
 */
notifySlack(slackObject: object) {

    const /** @type {?} */ header = new Headers();
    header.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

    return this.http.post(this.slackUrlToken,
      `payload=${ JSON.stringify(slackObject)}`, {
        headers: header
      })
      .map((test: Response) => {
        console.log(test);
        return Observable.of(test.text());
      });
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: Injector, },
];
}

function FeedbackService_tsickle_Closure_declarations() {
/** @type {?} */
FeedbackService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FeedbackService.ctorParameters;
/** @type {?} */
FeedbackService.prototype.slackUrlToken;
/** @type {?} */
FeedbackService.prototype.http;
/** @type {?} */
FeedbackService.prototype.injector;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
